import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/views/Index'
import Login from '@/views/Login/login'
import Register from '@/views/Login/register'
import ResetPassword from '@/views/Login/resetPassword'
import DesignerAuth from '@/views/Login/designerAuth'
import FactoryAuth from '@/views/Login/factoryAuth'
import Home from '@/views/Home/home'
import OrderDem from '@/views/Order/orderDem'
import OrderCreate from '@/views/Order/orderCreate'
import OrderDes from '@/views/Order/orderDes'
import OrderMall from '@/views/Order/orderMall'
import School from '@/views/School/index'
import schoolDetail from '@/views/School/schoolDetail'
import Mall from '@/views/Mall/index'
import News from '@/views/News/index'
import goodsDetail from '@/views/Mall/goodsDetail'
import agreement from '@/views/News/agree'
import newsDetail from '@/views/News/newsDetail'
import user from '@/views/User/user.vue'
import information from '@/views/User/children/information.vue'
import money from '@/views/User/children/money.vue'
import withdraw from '@/views/User/children/withdraw.vue'
import safeCenter from '@/views/User/children/safeCenter.vue'
import desOrderList from '@/views/User/children/desOrder.vue'
import orderList from '@/views/User/children/order.vue'
import addressList from '@/views/User/children/addressList.vue'
import orderDetail from '@/views/User/children/orderDetail.vue'
import coupon from '@/views/User/children/coupon.vue'
import invoice from '@/views/User/children/invoice.vue'
import support from '@/views/User/children/support.vue'
import threeModel from '@/views/Order/3Dmodel'
import chat from '@/views/Chat/index'
import pdfPreview from '@/views/Order/pdfPreview'
import ai from '@/views/Vision/AI'
import aides from '@/views/Aides/index'
import downLoad from '@/views/Home/software'
import productDetails from '@/views/Mall/productDetails'
import orthodonticsCreateOrder from '@/views/Order/orthodonticsOrder/orthodonticsCreateOrder'
import bracket from '@/views/Order/activeModification/orderCreateBracket'
import match from '@/views/Vision/matchUpload'
import designer from '@/views/User/children/designer'
import blockDesList from '@/views/User/children/blockDesList'
import Contact from '@/views/Login/contact'
Vue.use(Router)

const routes = [{
    path: '/',
    name: 'home',
    component: Index,
    redirect: '/home',
    children: [{
        path: "home",
        component: Home,
        meta: {
          SubNav: true
        }
      },
      {
        path: "order/dem",
        component: OrderDem,
        meta: {
          SubNav: true
        }
      },
      {
        path: "order/create",
        component: OrderCreate,
        meta: {
          SubNav: true
        }
      },
      {
        path: "order/des",
        component: OrderDes,
        meta: {
          SubNav: true
        }
      },
	  {
	    path: "order/mall",
	    component: OrderMall,
	    meta: {
	      SubNav: true
	    }
	  },
      {
        path: "school",
        component: School,
        meta: {
          SubNav: true
        }
      },
      {
        path: "news",
        component: News,
        meta: {
          SubNav: true
        }
      },
      {
        path: "mall",
        component: Mall,
        meta: {
          SubNav: true
        }
      },
      {
        path: "goodsDetail",
        component: goodsDetail,
        meta: {
          SubNav: false
        }
      },
      {
        path: "ai",
        component: ai,
        meta: {
          SubNav: true
        }
      },
      {
        path: "/match/upload",
        component: match,
      },
      {
        path: "/downLoad",
        name: "downLoad",
        component: downLoad
      },
      {
        path: "/productDetails",
        name: "productDetails",
        component: productDetails
      },
      {
        path: "order/orthodonticsCreateOrder",
        name: "orthodonticsCreateOrder",
        component: orthodonticsCreateOrder
      },
      {
        path:'order/active/bracket',
        name:'bracket',
        component: bracket
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/register",
    name: "register",
    component: Register
  },
  {
  	path: "/resetPassword",
  	name: "resetPassword",
  	component: ResetPassword
  },
  {
    path:"/contact",
    name:"contact",
    component: Contact
  },
  {
    path: "/designerAuth",
    name: "designerAuth",
    component: DesignerAuth
  },
  {
    path: "/factoryAuth",
    name: "factoryAuth",
    component: FactoryAuth
  },
  {
    path: "/newsDetail",
    name: "newsDetail",
    component: newsDetail
  },
  {
    path: "/agreement",
    name: "agreement",
    component: agreement
  },
  {
    path: "/schoolDetail",
    name: "schoolDetail",
    component: schoolDetail
  },
  {
    path: "/3Dmodel",
    name: "3Dmodel",
    component: threeModel
  },
  {
    path: "/chat",
    name: "chat",
    component: chat
  },
  {
    path: "/aides",
    name: "aides",
    component: aides
  },
  {
    path: "/pdfPreview",
    name: "pdfPreview",
    component: pdfPreview
  },
  {
    path: '/user',
    name: 'user',
    component: user,
    redirect: '/user/information',
    children: [
      {path: 'information', name: '基本信息', component: information},
      {path: 'money', name: '钱包管理', component: money},
      {path: 'withdraw', name: '提现管理', component: withdraw},
      {path: 'safeCenter', name: '安全中心', component: safeCenter},
      {path: 'desOrderList', name: '我的设计单', component: desOrderList},
      {path: 'invoice', name: '发票管理', component: invoice},
      {path: 'orderList', name: '订单列表', component: orderList},
      {path: 'orderDetail', name: '订单详情', component: orderDetail},
      {path: 'information', name: '账户资料', component: information},
      {path: 'addressList', name: '收货地址', component: addressList},
      {path: 'coupon', name: '我的优惠', component: coupon},
      {path: 'support', name: '售后服务', component: support},
      {path: 'invite', name: '邀约设计师', component: designer},
      {path: 'blockDesList', name: '拉黑设计师', component: blockDesList},
    ]
  },
]

const router = new Router({
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js